package co.uk.sacursoftware.ssinventory.util

import kotlinx.coroutines.suspendCancellableCoroutine
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Uint8Array
import kotlin.coroutines.resume

internal actual class ImageByteStore actual constructor() {
    actual suspend fun getBytes(key: String): ByteArray? = suspendCancellableCoroutine { cont ->
        val requestUrl = cacheUrl(key)
        js("window.caches").open("ssinventory-images").then({ cache ->
            cache.match(requestUrl).then({ response ->
                if (response == null) {
                    cont.resume(null)
                } else {
                    response.arrayBuffer().then({ buf ->
                        cont.resume(arrayBufferToBytes(buf as ArrayBuffer))
                    }, { cont.resume(null) })
                }
            }, { cont.resume(null) })
        }, { cont.resume(null) })
        Unit
    }

    actual suspend fun putBytes(key: String, bytes: ByteArray) = suspendCancellableCoroutine { cont ->
        val requestUrl = cacheUrl(key)
        val u8 = bytesToUint8(bytes)
        val blob = js("new Blob([u8], { type: 'image/jpeg' })")
        val response = js("new Response(blob)")
        js("window.caches").open("ssinventory-images").then({ cache ->
            cache.put(requestUrl, response).then({
                cont.resume(Unit)
            }, { cont.resume(Unit) })
        }, { cont.resume(Unit) })
        Unit
    }

    actual suspend fun removeBytes(key: String) = suspendCancellableCoroutine { cont ->
        val requestUrl = cacheUrl(key)
        js("window.caches").open("ssinventory-images").then({ cache ->
            cache.delete(requestUrl).then({
                cont.resume(Unit)
            }, { cont.resume(Unit) })
        }, { cont.resume(Unit) })
        Unit
    }
}

private fun cacheUrl(key: String): String = "https://ssinventory.local/img/$key"

private fun bytesToUint8(bytes: ByteArray): Uint8Array {
    val size = bytes.size
    val u8 = js("new Uint8Array(size)") as Uint8Array
    for (i in bytes.indices) {
        u8.asDynamic()[i] = bytes[i]
    }
    return u8
}

private fun arrayBufferToBytes(buffer: ArrayBuffer): ByteArray {
    val u8 = Uint8Array(buffer)
    val out = ByteArray(u8.length)
    for (i in 0 until u8.length) {
        out[i] = u8.asDynamic()[i] as Byte
    }
    return out
}
